import { toValue, type MaybeRefOrGetter } from 'vue'
import { useEventBus } from '@vueuse/core'
import { FetchMethod } from '../models/api/fetch-method'
import { ApiRequestStatus } from '../models/api/api-request-status'
import { useApiClient } from './api/useApiClient'
import { EventKey } from '../events/event-key'

export const useCoverObjective = (dialogId: MaybeRefOrGetter<string>) => {
  const { execute, status } = useApiClient()
  const objectiveUpdatedBus = useEventBus(EventKey.objectiveUpdated)

  const cover = async (objectiveId: string) => {
    await execute({
      method: FetchMethod.PUT,
      endpoint: `dialog/${toValue(dialogId)}/covered-objectives/${objectiveId}`,
      omitOrganization: false,
      body: {},
    })
    if (status.value === ApiRequestStatus.Success) {
      objectiveUpdatedBus.emit()
      return true
    }
    return false
  }

  const uncover = async (objectiveId: string) => {
    await execute({
      method: FetchMethod.DELETE,
      endpoint: `dialog/${toValue(dialogId)}/covered-objectives/${objectiveId}`,
      omitOrganization: false,
      body: {},
    })
    if (status.value === ApiRequestStatus.Success) {
      objectiveUpdatedBus.emit()
      return true
    }
    return false
  }

  const setCovered = async (objectiveId: string, covered: boolean) => {
    return covered ? cover(objectiveId) : uncover(objectiveId)
  }

  return { cover, uncover, setCovered, status }
}
